import { getWorkItemTypeRegistry } from '@/config/work-items/configLoader';

type UserLikeWithCommentRoles = {
  role?: unknown;
  system_role?: unknown;
  membership_role?: unknown;
  client_membership_role?: unknown;
  source_membership_role?: unknown;
  is_admin?: unknown;
  isAdmin?: unknown;
  is_root?: unknown;
  isRoot?: unknown;
  can_admin?: unknown;
  canAdmin?: unknown;
  permissions?: {
    role?: unknown;
    admin?: unknown;
    can_admin?: unknown;
    canAdmin?: unknown;
  } | null;
} | null | undefined;

const PRIVILEGED_COMMENT_ROLES = new Set(['admin', 'owner', 'root', 'super_admin', 'system_admin']);

const normalizeRole = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : null;
};

const isTruthyFlag = (value: unknown): boolean => {
  return value === true || value === 'true';
};

export function hasPrivilegedCommentRole(user: UserLikeWithCommentRoles): boolean {
  if (!user) {
    return false;
  }

  if (
    isTruthyFlag(user.is_admin)
    || isTruthyFlag(user.isAdmin)
    || isTruthyFlag(user.is_root)
    || isTruthyFlag(user.isRoot)
    || isTruthyFlag(user.can_admin)
    || isTruthyFlag(user.canAdmin)
    || isTruthyFlag(user.permissions?.admin)
    || isTruthyFlag(user.permissions?.can_admin)
    || isTruthyFlag(user.permissions?.canAdmin)
  ) {
    return true;
  }

  return [
    normalizeRole(user.role),
    normalizeRole(user.system_role),
    normalizeRole(user.membership_role),
    normalizeRole(user.client_membership_role),
    normalizeRole(user.source_membership_role),
    normalizeRole(user.permissions?.role),
  ].some((role) => Boolean(role && PRIVILEGED_COMMENT_ROLES.has(role)));
}

export function normalizeCommentAccessStatus(status?: string | null): string {
  return typeof status === 'string' ? status.trim().toLowerCase().replace(/\s+/g, '_') : '';
}

export function isReadOnlyCommentWorkItemStatus(status?: string | null, itemType?: string | null): boolean {
  return isClosedCommentWorkItemStatus(status, itemType);
}

export function isClosedCommentWorkItemStatus(status?: string | null, itemType?: string | null): boolean {
  const normalized = normalizeCommentAccessStatus(status);
  if (itemType) {
    const configLoader = getWorkItemTypeRegistry();
    if (configLoader.isTerminalStatus(itemType, normalized)) return true;
  }
  return normalized === 'closed';
}

export function isResolvedCommentWorkItemStatus(status?: string | null, itemType?: string | null): boolean {
  const normalized = normalizeCommentAccessStatus(status);
  if (itemType) {
    const configLoader = getWorkItemTypeRegistry();
    const label = configLoader.getStatusLabel(itemType, normalized);
    if (label && normalized === 'resolved') return true;
  }
  return normalized === 'resolved';
}